module.exports = __webpack_public_path__ + "img/aperturaPuertas.ec2df81e.svg";